export function clear(object) {
  for (var property in object) {
    delete object[property]
  }
}

function getListenerMap(target, opt_create) {
  var listenerMap = target.ol_lm
  if (!listenerMap && opt_create) {
    listenerMap = target.ol_lm = {}
  }
  return listenerMap
}

export function listen(target, type, listener, opt_this, opt_once) {
  var listenerMap = getListenerMap(target, true)
  var listeners = listenerMap[type]
  if (!listeners) {
    listeners = listenerMap[type] = []
  }
  var listenerObj = findListener(listeners, listener, opt_this, false)
  if (listenerObj) {
    if (!opt_once) {
      // Turn one-off listener into a permanent one.
      listenerObj.callOnce = false
    }
  } else {
    listenerObj = /** @type {EventsKey} */ ({
      bindTo: opt_this,
      callOnce: !!opt_once,
      listener: listener,
      target: target,
      type: type,
    })
    /** @type {import("./events/Target.js").default} */
    target.addEventListener(type, bindListener(listenerObj))
    listeners.push(listenerObj)
  }

  return listenerObj
}

export function findListener(
  listeners,
  listener,
  opt_this,
  opt_setDeleteIndex
) {
  var listenerObj
  for (var i = 0, ii = listeners.length; i < ii; ++i) {
    listenerObj = listeners[i]
    if (listenerObj.listener === listener && listenerObj.bindTo === opt_this) {
      if (opt_setDeleteIndex) {
        listenerObj.deleteIndex = i
      }
      return listenerObj
    }
  }
  return undefined
}

/**
 * @param {EventsKey} listenerObj Listener object.
 * @return {ListenerFunction} Bound listener.
 */
export function bindListener(listenerObj) {
  var boundListener = function(evt) {
    var listener = listenerObj.listener
    var bindTo = listenerObj.bindTo || listenerObj.target
    if (listenerObj.callOnce) {
      unlistenByKey(listenerObj)
    }
    return listener.call(bindTo, evt)
  }
  listenerObj.boundListener = boundListener
  return boundListener
}

export function unlistenByKey(key) {
  if (key && key.target) {
    /** @type {import("./events/Target.js").default} */ ;(key.target).removeEventListener(
      key.type,
      key.boundListener
    )
    var listeners = getListeners(key.target, key.type)
    if (listeners) {
      var i = 'deleteIndex' in key ? key.deleteIndex : listeners.indexOf(key)
      if (i !== -1) {
        listeners.splice(i, 1)
      }
      if (listeners.length === 0) {
        removeListeners(key.target, key.type)
      }
    }
    clear(key)
  }
}

export function getListeners(target, type) {
  var listenerMap = getListenerMap(target)
  return listenerMap ? listenerMap[type] : undefined
}

function removeListeners(target, type) {
  var listeners = getListeners(target, type)
  if (listeners) {
    for (var i = 0, ii = listeners.length; i < ii; ++i) {
      /** @type {import("./events/Target.js").default} */ ;(target).removeEventListener(
        type,
        listeners[i].boundListener
      )
      clear(listeners[i])
    }
    listeners.length = 0
    var listenerMap = getListenerMap(target)
    if (listenerMap) {
      delete listenerMap[type]
      if (Object.keys(listenerMap).length === 0) {
        removeListenerMap(target)
      }
    }
  }
}

function removeListenerMap(target) {
  delete target.ol_lm
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/directives/events.js